export default {
    login: {
        first: 'Tvoříme',
        second: 'řešení pro každého',
        third: 'Náš jednoduchý a inteligentní design vám poskytne nástroje k přeměně dat v reálném čase na okamžité výsledky ve výkonu firmy.',
        first_flower: 'we colour the public space with our durable plant concepts',
        second_flower: '',
        third_flower: 'We provide flowering public green spaces and large gardens throughout Europe. We do this by supplying and planting flower bulbs, wild flowers and perennials.',
      desc: 'Přihlaste se za pomoci informací uvedených níže',
        username: 'Email',
        password: 'Heslo',
        successful: 'Přihlášení úspěšné',
        logout: 'Odhlášení',
        log: 'Přihlášení',
        in: '',
    },
    dashboard: {
        title: 'Zařízení',
        search: 'Hledej',
        dealer_view: 'Zobrazení pro dealera',
        no_lora_id: 'Žádné LoRa ID',
        nav: {
            type: 'Typ',
            location: 'Poloha',
            batch: 'Kalibrace',
            remark: 'Poznámka',
            lqi: 'Spojení',
            lqi_hover: 'Indikátor kvality připojení',
            unit: 'Zařízení',
            last_event: 'Poslední událost',
            l_update: 'Poslední data',
            timing: 'Dynamické časování',
            sensing: 'Pokročilé nastavení',
            notification: 'Notifikacie',
            customer: 'Zákazník',
            favourite: 'Oblíbené',
        },
        bulk_setup: {
            substrate_properties: 'Vlastnosti substrátu',
            frame_selection: 'Výběr rámce',
            critical_value: 'Prahové hodnoty pro notifikace',
            payload_error: 'Formát rámece měření vybraných zařízení není totožný',
            hundred_tx_power: 'Počítáno pro 100% vysílací výkon.',
            version_error: 'Výpočet životnosti je k dispozici pouze pro zařízení s identickými verzemi.',
            sa_error: 'Výpočet životnosti je k dispozici pouze pro zařízení bez sebeuvědomění (zkontrolujte prosím na stránce s podrobnostmi o zařízení).',
            sa_version_error: 'Výpočet životnosti je k dispozici pouze pro zařízení s identickými verzemi bez sebeuvědomění (informace o životnosti zařízení naleznete na stránce s podrobnostmi o zařízení).',
            version_identical_sa_error: 'Profilauswahl ist nur für Geräte mit derselben Version verfügbar.',
            batch_type_error: 'Typ kalibrace není identický (vlastnosti jsou zakázány)',
            batch_missing_error: 'Není nastavena jedna nebo více kalibrací (vlastnosti jsou zakázány)',
            batch_all_error: 'Chcete-li pokračovat, nastavte všechny vlastnosti',
            affected: 'Změna byla použita na {count} zařízení',
            identical_version_error: 'Pro hromadnou úpravu vyberte zařízení s identickými verzemi (změna intervalu měření není možná).',
            measurement_interval_cant: 'Změna intervalu měření není k dispozici.',
            measurement_sets_cant: 'Akumulace, interval stahování a opakování stahování nejsou k dispozici.',
            sa_active_error: 'Vyberte zařízení bez aktivního profilu Self Awareness pro změnu „Akumulace“, „Interval stahování“ a „Opakování stahování“',
            sa_mixed_error: 'K úpravě výběru rámečku vybírejte pouze zařízení s nebo bez aktivního profilu sebeuvědomění (kombinace není možná).',
            expert_mode: '*Expertní režim povolen!! Zobrazují se všechny možnosti, když je povoleno Sebeuvědomění.',
            data_auto_scaling: '*Automatické Škálování Dat zapnuto! Senzor používá Kalibrační Koeficienty Měřítka. ',
        },
        remark: {
            double_click: 'Dvojitým kliknutím',
            to_add: 'přidáte hodnotu',
            history: 'Historie poznámok',
            show_history: 'Zobrazit historii poznámek',
        },
    },
    map: {
        calculated: 'Vypočítané umístění',
        manual: 'Ruční umístění',
    },
    detail: {
        new_calib_point: 'Přidat nový kalibrační bod',
        remove_calib_point: 'Odebrat kalibrační bod',
        raw_value: 'Hrubá hodnota',
        calibrate_min: 'Kalibrovat min.',
        calibrate_max: 'Kalibrovat max.',
        apply_calib: 'Použít kalibraci na vlastnosti',
        reset_minmax: 'Resetujte minimální a maximální hodnoty',
        reset_calib: 'Resetovat na přiřazenou kalibraci',
        select_props: 'Vyberte vlastnosti pro které chcete kalibrovat',
        save_props: 'Uložit do vybraných vlastností',
        percent: 'VWC',
        batch: 'Kalibrace',
        selected_batch: 'Vybraná kalibrace',
        raw: 'Raw',
        warning: 'Pozor',
        warning_vwc: 'Hodnota pro VWC nebo ekvivalent RAW je neplatná. Opravte hodnoty tak, aby byly větší než minimální, menší než maximální nebo jakákoli jiná neexistující hodnota.',
        measured_min: 'Měřené minimum',
        measured_max: 'Měřené maximum',
        select_props: 'Vyberete vlastnosti',
        lqi: 'Kvalita spojení',
        lqi_calculated: 'Vypočítáno pomocí stanic.',
        map: 'Umístění senzora',
        sensor_setting: 'Nastavení senzora',
        etentacles_setting: 'Nastavení iTentacles',
        min_value: 'Minimální hodnota',
        last_value: 'Poslední hodnota',
        max_value: 'Maximální hodnota',
        select_data: 'Výběr dat',
        missing: 'Nejsou dostupné data',
        moisture_calibration: 'Kalibrace VWC',
        warning_batch_calibration: 'Varování! Aktualizujete přiřazenou kalibraci!',
        warning_device_calibration2: 'Pozor! Chcete-li použít kalibraci na vlastnosti - klikněte na "Použít kalibraci na vlastnosti"',
        device_only_label: 'Kalibrace pouze pro zařízení',
        payload_format: 'Rámec měření (zařízení)',
        payload_format_change: 'Změňte rámec měření',
        payload_format_not_set: 'Zatím neaktualizováno',
        payload_format_changed: 'Poslední změna',
        payload_format_updated: 'Naposledy aktualizováno',
        format: 'Rámec',
        set_format: 'Nastavit rámec',

        dynamic_sensing: 'Pokročilé nastavení',
        measurement_frame: 'Rámec měření',
        none: 'Žádný',
        moisture: 'Vlhkost',
        temperature: 'Teplota',
        light: 'Světlo',
        measurement_sets: 'Akumulované sady měření',
        measurement_interval: 'Interval měření',
        sigfox_frames_transmitted: 'Sigfox Frames přenášeny',
        lora_connections: 'Lora připojení/síť',
        downlik_period: 'Downlinkové období',
        downlink_retries: 'Opakování downlinku',
        transmitting_power: 'Vysílací výkon',
        message_interval: 'Interval zprávy',
        sigfox_device_lifespan: 'Životnost zařízení SigFox',
        device_lifespan: 'Životnost zařízení',
        device_loralifespan: 'Životnost zařízení LoRa',
        downlink_max: 'Max efficiency',
        once_per_four: 'Jednou za 4 dny',
        once_per_two: 'Jednou za 2 dny',
        once_per_day: 'Jednou denně',
        twice_per_day: 'Dvakrát denně',
        set_dynamic_sensing: 'Nastavte pokročilá nastavení',
        sa_title: 'Sebeuvědomění',
        sa_select_profile: 'Aktivní profil',
        sa_enable_profile: 'Nastavit profil',
        sa_hover: 'Na základě profilu se nastavení zařízení mění na základě stavu komunikace/připojení',
        sa_automatic_mode: '*Možnosti spravované sebeuvědoměním jsou skryté',
    },
    lqi: {
        Excellent: 'Vynikající',
        Good: 'Dobrý',
        Average: 'Dostatečný',
        Limit: 'Omezený'
    },
    server_status: {
        title: 'Status servera',
    },
    privacy: {
        title: 'Zásady ochrany osobních údajů',
    },
    sigfox_coverage: {
        title: 'Pokrytí',
        coverage_error: 'Výpadek služby Pokrytí',
        unstable: 'Neexistuje žádné pokrytí a zařízení se nemusí synchronizovat.',
        works_underground: 'Spojení je silné a zařízení by mělo fungovat v podzemí nebo hluboko v interiéru.',
        possible_underground: 'Spojení je dostatečně silné, aby umožňovalo práci v podzemí nebo hluboko v interiéru.',
        works_indoor: 'Spojení je stabilní a zařízení by mělo fungovat v interiéru (nemusí fungovat pod zemí).',
        possible_indoor: 'Spojení je dostatečně stabilní, aby zařízení mohlo pracovat v interiéru. (nemusí fungovat pod zemí).',
        works_open: 'Spojení nemusí být stabilné ale zařízení by mělo fungovat na otevřeném poli.',
        possible_open: 'Zařízení získá spojení a existuje možnost, že by zařízení mělo fungovat na otevřeném poli.',
        coverage_env: "Umístění zařízení",
        coverage_env_greenhouse: "Skleník",
        coverage_env_indoors: "Uvnitř",
        coverage_env_outdoors: "Venku",
    },
    payload: {
        title: 'Soil 3XS zatížení',
    },
    export: {
        limit: 'Vyberte posledních x hodnot z vybraných zařízení Tentacle',
        info: {
            first: 'Exportovat',
            second: 'vybraných Tentacle',
            rest: 'Nejprve vyberte některé Tentacle z tabulky',
        },
        tabs: {
            date_range: 'Časové období',
            limit_values: 'Limitní hodnoty',
        },
    },
    contact_us: {
        title: 'Kontaktujte nás',
        subj: 'Předmět',
        mess: 'Vzkaz',
    },
    tooltips: {
        customer: 'Zobrazovací zařízení přiřazená tomuto zákazníkovi.',
        logout: 'Odhlášení',
        total_units: 'Počet zařízení',
        unit_name: 'Název Tentaclu',
        excel: 'Export do souboru Excel',
        csv: 'Export ve formátu CSV',
        search: 'nebo stiskněte',
        tentacle_missing: 'vyberte alespoň jeden',
        network: 'změnit zobrazené externí ID sítě',
    },
    buttons: {
        ok: 'Ok',
        login: 'Přihlášení',
        detail: 'Detail',
        apply: 'Použít změny',
        apply_range: 'Aplikovat rozsah',
        bulk: 'Hromadné nastavení',
        bulkdetail: 'Hromadný detail',
        cancel: 'Zrušit',
        send: 'Odeslat',
        export: 'Exportovat',
        delete_range: 'Smazat rozsah',
        next: 'Další',
        previous: 'Předchozí',
        save: 'Uložit',
    },
    metrics: {
        moisture: 'VWC',
        moisture_top: 'VWC Horní',
        moisture_middle: 'VWC Uprostřed',
        moisture_bottom: 'VWC Spodní',
        light: 'Světlo',
        temperature: 'Teplota',
        battery: 'Baterie',
        pressure: 'Tlak',
        pump_mode: 'Čerpadlo běží',
        gyroscope: 'Vibrace',
        events: 'Události',
        currents: 'Fázový proud',
        angles: 'Fázový úhel',
        over_vibration_stop: 'Zastavení proti vibracím',
    },
    timing: {
        t1: '15 minut',
        t2: '30 minut',
        t3: '1 hodina',
        t4: '2 hodiny',
        t5: '8 hodin',
        t6: 'Vypnout',
    },
    interval: {
        day: 'den',
        week: 'za týden',
        month: 'za měsíc',
        year: 'za rok',
    },
    notifications: {
        push: 'Notifikace',
    },
    sensing: {
        sens1: 'Aktuální Soil 3XT-4',
        sens2: 'Originalí 2x za hodinu',
        sens3: 'Vlhkost 4x za Hodinu',
        sens4: 'Vlhkost 3x za 45 min',
        sens5: 'Vlhost/Teplota 2x za 30 min',
        sens6: 'Vlkost/Teplota/Světlo 2x za 30 min',
    },
    info: {
        loading_data: 'Načítám data'
    },
    eventChart: {
        networkGatewaysCreated: 'Přidělování do sítě',
        networkGatewayActive: 'Zařízení ZAPNUTO',
        networkGatewayRemoved: 'Odstranění ze sítě',
        fportSettingsChange: 'Pokročilá změna nastavení LoRa',
        activeGatewayChange: 'Změna sítě',
        networkChangeRequest: 'Žádost o změnu sítě',
        networkDownlinkLimit: 'Limit downlinků',
        fportSettingsChange101Message: 'Aktualizace agregovaných nastavení zařízení',
        fportSettingsChange102Message: 'Aktualizace datových sazeb LoRa zařízení',
        fportSettingsChange103Message: 'Aktualizace nastavení opakování zařízení',
        activeGatewayChangeMessage: 'Síť zařízení {previous} byla změněna na {active}',
        networkChangeRequestMessage: 'Síť zařízení {previous} byla změněna na {new}',
        networkDownlinkLimitMessage: 'Byl dosažen limit LoRa downlinků. Příští dostupný downlink (nastavení) bude zítra.',
        networkGatewaysCreatedMessage: 'Zařízení bylo přiděleno do sítí [{networks}]',
        networkGatewayActiveMessage: 'Zařízení odeslalo první data v síti {network}',
        networkGatewayRemovedMessage: 'Zařízení bylo odebráno ze sítě {network}',
        sequenceMessage: 'Očekávané pořadové číslo bylo {previous} přišlo {actual}',
        ensBackupMessage: 'ENS změnil síť na {network} kvůli nedostupnosti sítě.',
        ensSequenceMessage: 'ENS změnil síť na {network} kvůli chybějící zprávě.',
        ansRegularMessage: 'ANS změnil síť na {network} kvůli špatnému připojení k síti.',
        ansExecutionMessage: 'ANS/ENS vybral síť {network}.',
        lqiMessage: 'Lqi je u minulých {badCount} zpráv nízká. Nejnovější bylo „{lqi}“',
        invalidMessage: 'Zařízení odesílá nesprávná data',
        ackMessage: 'Očekávaná aktualizace zařízení byla {expectedAt}',
        sequence: 'Chybí pořadové číslo',
        lqi: 'Nízké LQI',
        power: 'Změna vysílacího výkonu',
        settings: 'Nastavení změněno',
        invalid: 'Neplatná data',
        pendingChange: 'Čeká na změnu',
        pendingChangeMessage: 'Zařízení ještě nepoužije změněná nastavení.',
        verifiedChange: 'Ověřená změna',
        verifiedChangeMessage: 'Ověřená nastavení zařízení změněna pomocí downlinku.',
        ack: 'Nastavení nebyla použita',
        info: 'Info',
        warning: 'Varování',
        error: 'Chyba',
        latestEvent: 'poslední událost',
        sigfoxDeleted: 'Stav cloudu vypnutý',
        sigfoxCreated: 'Stav cloudu zapnuto',
        deviceOn: 'Zařízení ZAPNUTO',
        sigfoxDeletedMessage: 'Cloudové zařízení je nastaveno do stavu VYPNUTO',
        sigfoxCreatedMessage: 'Cloudové zařízení je nastaveno do stavu ZAPNUTO',
        deviceOnMessage: 'Zařízení odeslalo první data v síti SigFox',
        events: 'Události',
        message: 'Zpráva',
        default: 'Výchozí',
        changedBy: 'Změněno uživatelem {name}',
        customer: 'Změna zákazníka',
        calibration: 'Kalibrace změněna',
        calibrationMessage: 'Změna nastavení kalibrace.',
        customerMessage: 'Zákazník byl změněn na {name}.',
        baseCalibrationMessage: 'Základní kalibrace se změnila na {calibration}.',
        propertiesCalibrationMessage: 'Kalibrace se změnila na {properties}.',
        powerMessage: 'Nastavení vysílání zařízení změněno.',
        transmittingMessage: 'Vysílací výkon se změnil z {previous} na {actual}.',
        periodMessage: 'Období se změnilo z "{previous}" na "{actual}".',
        networkTypesMessage: 'Typ sítě změněn z „{previous}“ na „{actual}“.',
        sfFramesMessage: 'Sigfox vysílající rámec se změnil z „{previous}“ na „{actual}“.',
        spanMessage: 'Rozpětí intervalu měření se změnilo z {previous} na {actual} minut.',
        retriesMessage: 'Počet opakování se změnil z {previous} na {actual}.',
        settingsMessage: 'Nastavení zařízení změněno.',
        frameMessage: 'Rámec se změnil z "{previous}" na "{actual}".',
        intervalMessage: 'Interval se změnil z {previous} na {actual} minut.',
        accumulationMessage: 'Nahromadění se změnilo z {previous} na {actual} zpráv.',
        thresholdMessage: 'Přístroj naměřil kritické hodnoty.',
        criticalMessage: '{sensor} kritická hodnota senzoru {value}{unit} dosažena (nastavená prahová hodnota {threshold}{unit}).',
        threshold: 'Kritická hodnota',
        attentionMessage: 'Zařízení měřilo hodnoty pozornosti.',
        notificationMessage: '{sensor} dosažená hodnota pozornosti senzoru {value}{unit} (prahová hodnota {threshold}{unit}).',
        attention: 'Hodnota pozornosti',
        selfAwarenessChange: 'Sebeuvědomění',
        selfAwarenessChangeTooltipSequence: 'Použito nastavení sebeuvědomění.',
        selfAwarenessChangeTooltipLqi: 'Použito nastavení sebeuvědomění.',
        selfAwarenessChangeTooltipStandby: 'Nastavení sebeuvědomění ignorováno.',
        selfAwarenessChangeTooltipVwc: 'Nastavení sebeuvědomění ignorováno.',
        selfAwarenessChangeMessageSequence: 'Zjištěna chybějící zpráva a provedena nastavení sebeuvědomění pro profil {state} {profile}.',
        selfAwarenessChangeMessageLqi: 'Shodovalo se s {number} {lqi} LQI a spustilo sebeuvědomění na profilu {state} {profile}.',
        selfAwarenessChangeMessageStandby: 'Spuštění funkce Self Awareness bylo přeskočeno, protože zařízení je v pohotovostním režimu.',
        selfAwarenessChangeMessageVwc: 'Provedení Self Awareness bylo přeskočeno, protože zařízení naměřilo VWC pod 5 %.'
    },
    transmittingPower: {
        15: "125%",
        14: "100%",
        13: "80%",
        12: "65%",
        11: "50%",
        10: "40%",
        9: "33%",
        8: "25%",
        7: "20%"
    },
    downlinkPeriods: {
        0: {
            25: "Jednou za 4 dny",
            5: "Jednou za 2 dny"
        },
        1: "Jednou denně",
        2: "Dvakrát denně"
    },
    networkTypes: {
        1: "Pouze Sigfox",
        2: "Pouze LoRa",
        3: "Priorita posledního připojení",
        4: "Prioritní SigFox",
        5: "Prioritní LoRa"
    },
    sfFrames: {
        1: "Jeden snímek",
        2: "Tři snímky"
    },
    sensors: {
        Moist: 'VWC',
        light: 'Světlo',
        temp: 'Teplota',
        battery: 'Baterie'
    },
    slider: {
        header: {
            attention: 'Pozornost',
            critical: 'Kritický'
        }
    },
    header: {
        custom_name: "Vlastní název",
        generic_name: "Obecný název",
        network_sigfox: "Sigfox",
        network_lora: "LoRa",
    },
    network: {
        active_network: 'Aktivní síť',
        null: 'Neznámý',
        sigfox: 'Sigfox',
        helium: 'Helium',
        skynet: 'SkyNet',
    }
};
